const translations = {
    acresPerTank: 'Acres per tank',
    aerialDrone: 'Aerial Drone',
    appTank: 'Application tank',
    applicationDetails: 'Application Details',
    applicationMethod: 'Application method',
    applicationTankGal: 'Application tank (gal)',
    applicator: 'Applicator',
    applicatorName: 'Applicator name',
    applicatorTypeLabel: 'Applicator type',
    batches: 'Batches',
    caTitle: 'California Pesticide Use Report',
    carrierOther: 'Other',
    carrierRate: 'Carrier rate (gal/ac)',
    carrierRateGalPerAc: 'Carrier rate (gal/ac)',
    carrierType: 'Carrier type',
    chemigation: 'Chemigation',
    closeButton: 'Close',
    comingSoonBody:
        'Compliance reporting for this state is coming soon. Federal FIFRA summary is available on request.',
    comingSoonTitle: 'State compliance report coming soon',
    commercial: 'Commercial',
    county: 'County',
    crop: 'Crop',
    customerAddress: 'Customer address',
    customerName: 'Customer name',
    date: 'Date applied',
    datePdf: 'Date',
    dicambaFlag: 'Dicamba',
    downloadPdfButton: 'Download PDF',
    epaColumn: 'EPA Reg #',
    faaNNumber: 'FAA N-number',
    fallbackTitle: 'State Compliance Report',
    fieldName: 'Field',
    groundBoom: 'Ground Boom',
    gustSpeed: 'Gust speed (mph)',
    humidity: 'Humidity (%)',
    license: 'License',
    licenseState: 'License state',
    locationDescription: 'Location description',
    methodLabel: 'Method',
    mixTank: 'Mix tank',
    mixTankGal: 'Mix tank (gal)',
    mnTitle: 'Minnesota Application Report',
    nameLabel: 'Name',
    noncommercial: 'Non-commercial',
    nyTitle: 'New York Application Record',
    oil: 'Oil',
    orderColumn: 'Order',
    other: 'Other',
    private: 'Private',
    productColumn: 'Product',
    rateColumn: 'Rate',
    recordedAt: 'Recorded at',
    restrictedUseFlag: 'RUP',
    signature: 'Signature',
    signatureDate: 'Date',
    signatureLine: 'Signature',
    signedBy: 'Signed by',
    state: 'State',
    tankMix: 'Tank Mix',
    tankVolume: 'Tank / Volume',
    targetPest: 'Target pest',
    temperature: 'Temperature (°F)',
    totalAcres: 'Total acres',
    totalApplied: 'Total Applied',
    totalAppliedColumn: 'Total applied',
    totalSprayVolume: 'Total spray volume (gal)',
    totalSprayVolumeGal: 'Total spray volume (gal)',
    typeLabel: 'Type',
    unlicensedRemediation:
        'Remove the unlicensed product from the mix or transfer to a licensed applicator before generating the report.',
    unlicensedWarningBody:
        'One or more products in this mix are not licensed for application in this state. PDF generation is disabled until the mix is compliant.',
    unlicensedWarningTitle: 'Unlicensed product detected',
    water: 'Water',
    weatherAtApplication: 'Weather at Application',
    weatherUnavailable: 'Weather data unavailable',
    windDirection: 'Wind direction',
    windSpeed: 'Wind speed (mph)'
};

export default translations;
